import React, { useState, useEffect } from 'react';
import { alertsAPI } from '../services/api';
import './MedicationAlerts.css';

const MedicationAlerts = ({ houseId }) => {
  const [alerts, setAlerts] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAlerts();
    const interval = setInterval(loadAlerts, 60000); // Refresh every minute
    return () => clearInterval(interval);
  }, [houseId]);

  const loadAlerts = async () => {
    try {
      const response = await alertsAPI.getAll(houseId, 30);
      setAlerts(response.data);
    } catch (error) {
      console.error('Error loading alerts:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return null;
  }

  const hasAlerts = alerts && (alerts.low_stock_items.length > 0 || alerts.expiring_items.length > 0);

  if (!hasAlerts) {
    return null;
  }

  return (
    <div className="medication-alerts">
      {alerts.low_stock_items.length > 0 && (
        <div className="alert-section low-stock">
          <h3>⚠️ Low Stock Items</h3>
          <ul>
            {alerts.low_stock_items.map((item) => (
              <li key={item.id}>
                <strong>{item.name}</strong> - {item.quantity}{item.unit ? ` ${item.unit}` : ''} left
                {item.low_stock_threshold && (
                  <span> (threshold: {item.low_stock_threshold})</span>
                )}
                {item.house_name && <span className="house-name"> - {item.house_name}</span>}
              </li>
            ))}
          </ul>
        </div>
      )}

      {alerts.expiring_items.length > 0 && (
        <div className="alert-section expiring">
          <h3>⏰ Expiring Medications</h3>
          <ul>
            {alerts.expiring_items.map((item) => (
              <li key={item.id}>
                <strong>{item.name}</strong> - Expires in {item.days_until_expiry} days
                {item.expiry_date && (
                  <span> ({new Date(item.expiry_date).toLocaleDateString()})</span>
                )}
                {item.house_name && <span className="house-name"> - {item.house_name}</span>}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default MedicationAlerts;

